// Autogenerated from `packages/@members/copy/models.generated/__model__.ts.hbs`

export const Bookmarks = {
  LimitReached: 'limitReached',
  Manage: 'manage',
  GenericError: 'genericError',
} as const;
